import { useState } from "react"
import { useField } from "formik"
import { makeStyles } from "tss-react/mui"
import { Stack, TextareaAutosize, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../../buttons/StandardButton"
import { AttendeeDetails } from "./attendeesTypes"

const useStyles = makeStyles()((theme) => ({
    description: {
        color: theme.palette.text.primary,
    },
    textarea: {
        width: "100%",
        minHeight: "10rem",
        padding: "0.75rem",
        fontSize: "1rem",
        borderRadius: "0.75rem",
        color: theme.palette.tailwind.slate[950],
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
        resize: "none",
        outline: "none",
        "&:focus": {
            borderColor: theme.palette.primary.main,
        },
        "&::placeholder": {
            color: theme.palette.tailwind.slate[500],
        },
    },
}))

type AttendeesDrawerContentParseProps = {
    handleCloseDrawer: () => void
}

export function AttendeesDrawerContentParse({ handleCloseDrawer }: AttendeesDrawerContentParseProps) {
    const { classes } = useStyles()
    const [{ value: attendees }, , attendeesHelpers] = useField<AttendeeDetails[]>("attendees")
    const [bulkText, setBulkText] = useState("")

    const handleParse = () => {
        const lines = bulkText.trim().split("\n")
        const newAttendees = lines
            .map((line) => {
                const parts = line.split(",").map((p) => p.trim())
                if (parts.length >= 2) {
                    const [name, company] = parts
                    return { name, company, isExternal: false }
                }
                return null
            })
            .filter((item) => item !== null)

        attendeesHelpers.setValue([...newAttendees, ...(attendees ?? [])])
        handleCloseDrawer()
    }

    return (
        <Stack flexGrow="1" justifyContent="space-between">
            <Stack gap="1rem">
                <LocalizedStrict id="create-order-confirm-booking-dialog-bulk-add-attendees-description">
                    <Typography variant="body1" className={classes.description}>
                        Input one name and company per line.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict
                    id="create-order-confirm-booking-dialog-bulk-add-attendees-field"
                    attrs={{ placeholder: true }}
                >
                    <TextareaAutosize
                        className={classes.textarea}
                        placeholder="Name, Company"
                        value={bulkText}
                        onChange={(e) => setBulkText(e.target.value)}
                    />
                </LocalizedStrict>
            </Stack>
            <LocalizedStrict id="create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button">
                <StandardButton variant="contained" onClick={handleParse}>
                    Add participants
                </StandardButton>
            </LocalizedStrict>
        </Stack>
    )
}
